import { gql } from "@apollo/client";

export const GET_HEADER_CARD_DATA = gql`
query GetCardData {
  getCardData {
    totalMember
    totalParty
    totalLossOfMember
    totalCandidates
    totalPublicForum
  }
}
`

